import { COMPANY } from './company';

export const WA_NUMBER  = COMPANY.whatsapp;
export const TEL_NUMBER = COMPANY.phone.replace(/\s/g, '');
export const WA_BASE    = `https://wa.me/${WA_NUMBER}`;
export const TEL        = `tel:${TEL_NUMBER}`;

export function buildWAUrl(message: string): string {
  return `${WA_BASE}?text=${encodeURIComponent(message)}`;
}

const PAGE_MESSAGES: Record<string, string> = {
  '/':              'Hi Big Bird Travel, I need help planning a trip.',
  '/about':         'Hi Big Bird Travel, I would like to learn more about your services.',
  '/visas':         'Hi Big Bird Travel, I need help with a visa application.',
  '/tour-packages': 'Hi Big Bird Travel, I am interested in booking a holiday package.',
  '/uae-tours':     'Hi Big Bird Travel, I want to book a UAE tour or activity.',
  '/flights':       'Hi Big Bird Travel, I need help booking flights.',
  '/hotels':        'Hi Big Bird Travel, I need help booking a hotel.',
  '/umrah':         'Hi Big Bird Travel, I am interested in an Umrah package.',
  '/corporate':     'Hi Big Bird Travel, I need help with corporate travel.',
  '/insurance':     'Hi Big Bird Travel, I need travel insurance.',
  '/contact':       'Hi Big Bird Travel, I would like to get in touch.',
  '/blog':          'Hi Big Bird Travel, I need help planning a trip.',

  // Visa sub-pages — kept specific so the always-visible mobile sticky bar
  // (Call / WhatsApp / Get Quote) carries the same intent the visitor just
  // read about, instead of falling back to a generic message.
  '/visas/uae-visit-visa':  'Hi Big Bird Travel, I need help with a UAE visit visa application.',
  '/visas/schengen-visa':   'Hi Big Bird Travel, I need help with a Schengen visa application.',
  '/visas/uk-visa':         'Hi Big Bird Travel, I need help with a UK visa application.',
  '/visas/usa-visa':        'Hi Big Bird Travel, I need help with a USA visa application.',
  '/visas/canada-visa':     'Hi Big Bird Travel, I need help with a Canada visa application.',
  '/visas/australia-visa':  'Hi Big Bird Travel, I need help with an Australia visa application.',
  '/visas/azerbaijan-visa': 'Hi Big Bird Travel, I need help with an Azerbaijan visa application.',
  '/visas/malaysia-visa':   'Hi Big Bird Travel, I need help with a Malaysia visa application.',
  '/visas/saudi-visa':      'Hi Big Bird Travel, I am a UAE resident and need the Saudi multiple-entry visa. Please check my eligibility and share the price.',
  '/visas/golden-visa':     'Hi Big Bird Travel, I would like to check my eligibility for the UAE Golden Visa. Please advise the category and cost that fits my case.',
  '/visas/visa-extension':  'Hi Big Bird Travel, my UAE visit visa is expiring soon and I need to extend/renew it without leaving the country. Please advise the process and cost.',
  '/visas/family-visa':     'Hi Big Bird Travel, I am a UAE resident and want to sponsor my family on a residence visa. Please check my eligibility and the process.',
  '/visas/job-seeker-visa': 'Hi Big Bird Travel, I want to apply for a UAE Job Seeker Visa. Please advise the duration category and cost.',
  '/visas/transit-visa':    'Hi Big Bird Travel, I have a long layover at a UAE airport and want to check if I need a transit visa to leave the airport.',
  '/visas/freelance-visa':  'Hi Big Bird Travel, I want to apply for a UAE Freelance Visa/permit. Please advise the best free-zone package and cost.',
};

export function getPageMessage(pathname: string): string {
  if (pathname.startsWith('/tour-packages/')) {
    return 'Hello Big Bird Travel, I am interested in a tour package. Please share details and availability.';
  }
  if (pathname.startsWith('/uae-tours/')) {
    return 'Hello Big Bird Travel, I want to book a UAE tour. Please share availability and price.';
  }
  return PAGE_MESSAGES[pathname] ?? 'Hello Big Bird Travel, I need travel assistance.';
}

export function packageWAUrl(packageName: string, travellers = 1): string {
  return buildWAUrl(
    `Hi Big Bird Travel, I am interested in this package: "${packageName}" for ${travellers} traveller${travellers > 1 ? 's' : ''}. Please share availability and price.`
  );
}

export function tourWAUrl(tourName: string): string {
  return buildWAUrl(
    `Hi Big Bird Travel, I want to book the "${tourName}" tour. Please share availability and price.`
  );
}

export function visaWAUrl(visaType: string): string {
  return buildWAUrl(`Hi Big Bird Travel, I need help with my ${visaType} application.`);
}
